import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken, TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null); // null = loading/unauth, object = authed
  const [ready, setReady] = useState(false);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setAdmin(null);
      setReady(true);
      return;
    }
    try {
      const { data } = await api.get("/admin/me");
      setAdmin(data);
    } catch {
      setAuthToken(null);
      setAdmin(null);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/admin/login", { email, password });
    setAuthToken(data.access_token);
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = () => {
    setAuthToken(null);
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, ready, login, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
};
